import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";

const TextInputTag = ({
  label,
  length,
  name,
  defaultValue,
  multiple,
  required,
  placeholder,
}) => {
  const [visibility, setVisibility] = useState(true);

  const handleDelete = () => {
    setVisibility(false);
  };
  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-end w-full" : "hidden"}
    >
      <div className="w-full">
        <label className="label">
          <span className="text-md font-semibold">
            {multiple && length ? label + " " + length : label}
          </span>
        </label>
        <textarea
          row={4}
          name={visibility ? name : ""}
          defaultValue={defaultValue}
          type="Text"
          className="textarea textarea-bordered h-24 w-full"
          required={required}
          placeholder={placeholder ? placeholder : ""}
        />
      </div>
      <div className={!multiple && "hidden"}>
        <button
          type="button"
          onClick={handleDelete}
          className="btn  btn-sm btn-circle"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default TextInputTag;
